module.exports = __webpack_public_path__ + "img/opieka_medyczna.ac5b3677.jpg";